/* global pca */
import $ from 'jquery';

/**
 * Validate the visible student fields
 */
class InstitutionReminder {
    constructor () {
        // Buttons
        this.$registerSubmit = $('.js-register-submit');

        // Tracking Variables
        this.reminderInputClicked = false;
        this.institutionClicked   = false;

        // Inputs
        this.$institutionInput = $('.js-institution-field input');
        this.$addressWrapper   = $('.js-institution-reminder');
        this.$addressInputs    = this.$addressWrapper.find('input');

        // Listen for reminder change
        if (this.$addressInputs.length) {
            this.$addressInputs.on('click change', () => {
                this.reminderInputClicked = true;
            });
        }

        // Listen for institution change by user
        this.$institutionInput.on('change', () => {
            this.institutionClicked = true;
        });

        // Listen for institution change by PCA
        InstitutionReminder.listenForPCA();

        // Button Events
        this.$registerSubmit.on('click', $.proxy(this.submitClick, this));
    }

    static listenForPCA () {
        // Listen for when PCA changes fields and fire change events for the fields
        if (typeof pca.on !== 'undefined') {
            pca.on('load', function (type, id, control) {
                control.listen('populate', function (address) {
                    if (this.fields.length) {
                        let i;

                        for (i = 0; i < this.fields.length; i += 1) {
                            const $input = $(`input[name='${this.fields[i].element}']`);

                            if ($input.length) {
                                $input.trigger('change');
                            }
                        }
                    }
                });
            });
        }
    }

    submitClick () {
        let reminderCheck = true;

        /**
         * Institution reminder
         */
        if (this.reminderInputClicked && !this.institutionClicked) {
            let reminderString     = 'It looks like you\'re updating your mailing address. Are your Institution details also up to date?';
            const institutionValue = this.$institutionInput.val();

            if (institutionValue.length) {
                reminderString += `\n\n"${institutionValue}"`;
            }

            reminderString += '\n\nPress OK to continue, or press Cancel to go back and edit your Institution.';

            reminderCheck = confirm(reminderString);
        }

        // Have all checks passed?
        return reminderCheck;
    }
}

export default InstitutionReminder;
